import { observable, makeObservable } from 'mobx';

import { store } from '@store';
import { assertIsDefined } from '@utils/assertIsDefined';

import { AbstractField } from './AbstractField';

export class SelectionButtonsField extends AbstractField<string, string> {
    @observable
    private options_?: Map<string, string>;

    constructor(params: string, name: string) {
        super(params, name);
        makeObservable(this);
    }

    public makeUpdateParams() {
        return this.fieldValue;
    }

    public getPreview(): string {
        if (!this.options_) {
            this.setData();
        }

        const options = this.options_;
        assertIsDefined(options, 'Field options are built by setData above');
        const value = this.fieldValue;

        return value ? (options.get(value) ?? '') : value;
    }

    public setData() {
        const {
            common: { fieldsParams },
        } = store;
        const fieldParams = fieldsParams.get(this.fieldName);
        assertIsDefined(fieldParams, `Field params of ${this.fieldName} are loaded with the entry type`);
        const { data } = fieldParams;

        const options = new Map<string, string>();

        data?.options?.forEach(option => {
            options.set(option.value, option.label);
        });

        this.options_ = options;
    }

    protected setFieldValue(value: string) {
        this.fieldValue = value;
    }
}
